import React, { Component } from 'react'
import { BrowserRouter as Router, Route, NavLink } from 'react-router-dom'


class PortfolioMenu extends Component {
 constructor(props) {
   super(props)
    this.state = {
      portfolioClass: ""
    }

  }

  isActive = (match, location) => {
    const { portfolioClass } = this.state;
    const newClass = match ? "portfolio-menu-introjs" : "";
    if (newClass !== portfolioClass)
      this.setState({ portfolioClass: newClass });
    return match;
  };




  render() {
    const { portfolioClass } = this.state;
    return (
      <div>
        <nav>
          <ul className={`portfolio-menu ${portfolioClass}`}>
            <li><NavLink activeClassName="active" isActive={this.isActive} to="/portfolio/intro"><span className="bullet">•</span> introdução</NavLink></li>
            <li><NavLink activeClassName="active" exact to="/portfolio/casas"><span className="bullet">•</span> casas</NavLink></li>
            <li><NavLink activeClassName="active" exact to="/portfolio/interiores"><span className="bullet">• </span>interiores</NavLink></li>
            <li><NavLink activeClassName="active" exact to="/portfolio/moveis"><span className="bullet">• </span>móveis</NavLink></li>
            <li><NavLink activeClassName="active" exact to="/portfolio/estudos"><span className="bullet">• </span>estudos</NavLink></li>
            <li><NavLink activeClassName="active" exact to="/portfolio/cronologia"><span className="bullet">• </span>cronologia</NavLink></li>
          </ul>
        </nav>
      </div>
    )
  }
}


export default PortfolioMenu


// WEBPACK FOOTER //
// ./src/PortfolioMenu.js